import styled from '../../../../theme'

const ControlWrapper = styled.div`
  height: 150px;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
`

export default ControlWrapper
